import { defineStore } from 'pinia'
import { computed, ref, readonly } from 'vue'

export const useGlobalStore = defineStore('global', () => {
  // State
  const modalActive = ref(false)
  const modalContentComponent = ref<any>(null)
  const modalContentData = ref<any>(null)
  const _showDetailsTable = ref(false)

  const isLoading = ref(false)
  const hasApiError = ref(false)

  // Computed
  const isModalActive = computed(() => modalActive.value)
  const isDetailTableActive = computed(() => _showDetailsTable.value)

  // Actions
  function updateLoadingState(value: boolean): void {
    isLoading.value = value
  }

  function updateApiErrorState(value: boolean): void {
    hasApiError.value = value
  }

  function showModal(component: any, data: any = {}): void {
    modalContentComponent.value = component
    modalContentData.value = data
    modalActive.value = true
  }

  function showDetailsTable(value: boolean): void {
    _showDetailsTable.value = value
  }

  function hideModal(): void {
    modalActive.value = false
    modalContentComponent.value = null
    modalContentData.value = null
  }

  return {
    // State
    isLoading: readonly(isLoading),
    hasApiError: readonly(hasApiError),
    modalActive: readonly(modalActive),

    // Computed
    isModalActive,
    modalContentComponent,
    modalContentData,
    isDetailTableActive,

    // Actions
    updateLoadingState,
    updateApiErrorState,
    showModal,
    hideModal,
    showDetailsTable
  }
})
